import React, { useEffect, useMemo, useState } from 'react';
import styles from './PanelHeaderColapsable.module.css';

const PanelHeaderColapsable = (props) => {
  const {
    titulo,
    className = '',
    colapsableEnMobile = true,
    breakpoint = 1024,
    expandido,
    expandidoInicial = true,
    onExpandidoChange,
    onColapsableChange,
    headerAcciones,
    mostrarAccionesColapsado = false,
    ariaLabelToggle,
    alwaysContent,
    children,
  } = props;

  const [isColapsable, setIsColapsable] = useState(
    colapsableEnMobile && typeof window !== 'undefined' && window.innerWidth <= breakpoint
  );
  const [expandidoInterno, setExpandidoInterno] = useState(expandidoInicial);

  const esControlado = typeof expandido === 'boolean';
  const estaExpandido = esControlado ? expandido : expandidoInterno;

  useEffect(() => {
    const handleResize = () => {
      const colapsable = colapsableEnMobile && window.innerWidth <= breakpoint;
      setIsColapsable(colapsable);
      if (!colapsable && !esControlado) {
        setExpandidoInterno(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint, colapsableEnMobile, esControlado]);

  useEffect(() => {
    if (onColapsableChange) {
      onColapsableChange(isColapsable);
    }
  }, [isColapsable, onColapsableChange]);

  const contenidoVisible = !isColapsable || estaExpandido;

  const actualizarExpandido = (nuevoValor) => {
    if (!esControlado) {
      setExpandidoInterno(nuevoValor);
    }
    if (onExpandidoChange) {
      onExpandidoChange(nuevoValor);
    }
  };

  const toggleExpandido = () => {
    if (!isColapsable) {
      return;
    }
    actualizarExpandido(!estaExpandido);
  };

  const mostrarAcciones = useMemo(() => {
    if (!headerAcciones) {
      return false;
    }
    return mostrarAccionesColapsado || contenidoVisible;
  }, [headerAcciones, mostrarAccionesColapsado, contenidoVisible]);

  return (
    <div className={`${styles.contenedor} ${className}`.trim()}>
      <div className={styles.header}>
        <div className={styles.titulo}>
          {isColapsable && (
            <button
              type="button"
              className={`${styles.botonToggle} ${!estaExpandido ? styles.colapsado : ''}`}
              onClick={toggleExpandido}
              aria-expanded={estaExpandido}
              aria-label={ariaLabelToggle || `Expandir o contraer ${titulo}`}
            >
              <span className={styles.icono}>▼</span>
            </button>
          )}
          <h3>{titulo}</h3>
        </div>

        {mostrarAcciones && <div className={styles.acciones}>{headerAcciones}</div>}
      </div>

      {alwaysContent}

      {contenidoVisible && <div className={styles.contenido}>{children}</div>}
    </div>
  );
};

export default PanelHeaderColapsable;
